import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';
import { styled } from '@material-ui/styles';
import { Box } from '@mui/material';

export const useStyles = makeStyles(theme => ({
	mainHeader: {
		padding: `${theme.spacing(1.5)}px 0`,
		'& .MuiTypography-root': {
			fontWeight: 700
		}
	},
	mainContent: {
		borderTop: `1px solid ${COLORS.BORDER}`
	},
	filters: {
		maxWidth: '320px !important',
		borderRight: `1px solid ${COLORS.BORDER}`,
		paddingTop: theme.spacing(4),
		paddingRight: theme.spacing(3)
	},
	cardSection: {
		padding: theme.spacing(4),
		paddingBottom: theme.spacing(6)
	},
	cards: {
		maxWidth: 464,
		minWidth: 230
	},
	clearIconButton: {
		marginBottom: -4
	},
	clearIconButtonHidden: {
		visibility: 'hidden'
	},
	paper: {
		padding: theme.spacing(2),
		marginLeft: theme.spacing(1),
		marginRight: 0,
		textAlign: 'left',
		backgroundColor: COLORS.WHITE,
		borderRadius: '20px 20px 20px 5px'
	},
	disclaimer: { marginLeft: '4px', color: COLORS.BACKGROUND_GREY_DARK },
	messageBox: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		overflowWrap: 'break-word',
		marginTop: '10px',
		marginBottom: '10px',
		marginLeft: '10px'
	}
}));

export const CustomInfoCard = styled(Box)(({ theme }) => ({
	borderRadius: theme.spacing(1.5),
	background: 'rgba(245, 246, 249, 1)',
	padding: `${theme.spacing(3)}px 25px`,
	marginTop: theme.spacing(3),
	boxShadow: '0px 2px 12px 0px rgba(33, 37, 41, 0.04)'
}));
